import React, { } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Card,
  Select,
} from '@lockerpm/design';

import {
} from "@ant-design/icons";

import userServices from "../../../../services/user";
import global from "../../../../config/global";
import { fetchUserInfo } from "../../../../utils/common";

const Preferences = () => {
  const { t } = useTranslation();
  const userInfo = useSelector((state) => state.auth.userInfo);
  console.log('userInfo', userInfo);

  const updateLanguage = (value) => {
    const payload = {
      customer_language: value
    }
    userServices.update_me(payload).then(async () => {
      await fetchUserInfo();
      global.pushSuccess(t('notification.success.account_details.updated'));
    }).catch((error) => {
      global.pushError(error)
    })
  }

  const updateUsersMe = (data) => {
    userServices.update_users_me(data).then(async () => {
      await fetchUserInfo();
      global.pushSuccess(t('notification.success.account_details.updated'));
    }).catch((error) => {
      global.pushError(error)
    })
  }

  return (
    <div>
      <Card bodyStyle={{ padding: 16 }} className="mb-4">
        <div className="flex justify-between">
          <p className="font-semibold">
            {t('account_details.preferences.language')}
          </p>
          <Select
            value={userInfo?.customer_language}
            style={{ width: 150 }}
            options={global.constants.LANGUAGES.map((o) => ({
              ...o,
              label: t(o.label)
            }))}
            onChange={(v) => updateLanguage(v)}
          />
        </div>
      </Card>
      <Card bodyStyle={{ padding: 16 }} className="mb-4">
        <div className="flex justify-between">
          <p className="font-semibold">
            {t('account_details.preferences.timeout')}
          </p>
          <Select
            value={userInfo?.timeout}
            style={{ width: 160 }}
            options={global.constants.VAULT_TIMEOUTS.map((o) => ({
              ...o,
              label: t(o.label)
            }))}
            onChange={(v) => updateUsersMe({ timeout: v })}
          />
        </div>
        <p className="mt-1">
          {t('account_details.preferences.timeout_desc')}
        </p>
      </Card>
      <Card bodyStyle={{ padding: 16 }} className="mb-4">
        <div className="flex justify-between">
          <p className="font-semibold">
            {t('account_details.preferences.timeout_action')}
          </p>
          <Select
            value={userInfo?.timeout_action}
            style={{ width: 160 }}
            options={global.constants.VAULT_TIMEOUT_ACTIONS.map((o) => ({
              ...o,
              label: t(o.label)
            }))}
            onChange={(v) => updateUsersMe({ timeout_action: v })}
          />
        </div>
        <p className="mt-1">
          {t('account_details.preferences.timeout_action_lock_desc')}
        </p>
        <p className="mt-1">
          {t('account_details.preferences.timeout_action_logout_desc')}
        </p>
      </Card>
    </div>
  );
}

export default Preferences;